import { render, staticRenderFns } from "./Pagamenti.vue?vue&type=template&id=972eaa48&"
import script from "./Pagamenti.vue?vue&type=script&lang=js&"
export * from "./Pagamenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports